import React from "react";

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-2" data-testid="legal-section">
      {heading && <h2 className="font-heading font-semibold text-lg text-brand-ink">{heading}</h2>}
      <div className="text-brand-ink/80 leading-relaxed space-y-2 text-sm sm:text-base">{children}</div>
    </section>
  );
}

export default function LegalLayout({ title, testid, icon: Icon, updated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid={testid}>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-brand-emerald/10 flex items-center justify-center shrink-0">
          {Icon && <Icon className="w-5 h-5 text-brand-emerald" />}
        </div>
        <h1 className="font-heading font-bold text-3xl text-brand-ink tracking-tight">{title}</h1>
      </div>
      {updated && <p className="text-xs text-brand-muted mb-6 ml-14">Last updated: {updated}</p>}
      <div className="bg-card border border-brand-line rounded-2xl p-6 sm:p-8 space-y-6">{children}</div>
    </div>
  );
}
